<template>
    <div class="content">
        <div class="content-wrap">
            <div class="top">
                <mq-layout mq="mobile">
                    <MobileMenubar></MobileMenubar>
                </mq-layout>
                <mq-layout mq="laptop+">
                    <LaptopMenubar></LaptopMenubar>
                </mq-layout>
            </div>

            <div class="container-login" align="center">
                <div class="main-text" align="center">
                    <p class="big-text" align="center">{{ l10.All_Parents_Signin_Title1 }}</p>
                    <p class="sub-text" align="center">{{ l10.All_Parents_Signin_Title1_Description1 }}</p>
                </div>
                

                <div class="start-kakao">
                    <input class="sub-kakao" type="submit" align="center" v-model="l10.All_Parents_Signin_With_Kakao" @click="showKakaoLayer">
                </div>
                <div v-if="lang !== 'ko'" class="kakao-alert">&#8251;&nbsp;{{ l10.All_Parents_Signin_With_Kakao_Alert}} </div>

                <div class="start-google">
                    <input class="sub-google" type="submit" align="center" v-model="l10.All_Parents_Signin_With_Google" @click="signinWithGoogle">
                    
                </div>
                
                <div class="seperator">
                    <div class="seperator1"></div> 
                    <div class="seperator2">&nbsp;{{l10.All_Parents_Signin_Or}}&nbsp;</div> 
                    <div class="seperator3"></div>
                    
                </div>
                
                <div class="start-email">
                    <input class="sub-email" type="submit" align="center" v-model="l10.All_Parents_Signin_With_Email" @click="signinWithEmail">
                </div>
                
                <div v-if="msg" class="next wrong-text">{{msg}}</div>

            </div>
        </div>

        <div class="container">
            <mq-layout mq="mobile">
                <MobileFooter></MobileFooter>
            </mq-layout>
            <mq-layout mq="laptop+">
                <LaptopFooter></LaptopFooter>
            </mq-layout>
        </div>

        <div class="dimmed_blk80" align="center" v-show="kakaoLayer">
            <div class="main-text" align="center">
                <p class="log-in" align="center">Log in</p>
            </div>
            
            <div class="kakaotalk-btn">
                <a class="img_kakaotalk_btn_bg" href="#" @click="signinWithKakao(true)">{{ l10.All_Parents_Signin_With_KakaoTalk }}</a>
            </div>
            
            <div class="kakaoelse-btn">
                <a class="img_kakaoelse_btn_bg" href="#" @click="signinWithKakao(false)">{{ l10.All_Parents_Signin_With_Kakao_Account }}</a>
            </div>
            
            <div class="close-btn">
                <a href="#" @click="closeKakaoLayer"><img src="@/assets/account/img-close-btn.png" srcset="@/assets/account/img-close-btn@2x.png 2x, @/assets/account/img-close-btn@3x.png 3x"></a>
            </div>
            
        </div> 
    </div>
</template>
<script>
import LaptopMenubar from "@/components/menubar/LaptopLayout.vue";
import MobileMenubar from "@/components/menubar/MobileLayout.vue";
import LaptopFooter from "@/components/footer/FooterLaptop.vue";
import MobileFooter from "@/components/footer/FooterMobile.vue";

import axios from 'axios'

export default {
    name: "Signin",
    components: { LaptopMenubar, MobileMenubar, LaptopFooter, MobileFooter },

    beforeCreate() {
        const lang = this.$route.query.lang;
        if (lang) {
		    this.$store.commit('setLanguage', lang);
        }
    },
    created() {
        const sessionId = this.$store.getters.sessionId//isSignedIn;
        if (this.$store.getters.sessionId && this.$store.getters.accountId) {
            this.$store
                .dispatch("verifySession", { sessionId })
                .then(() => {
                    this.redirect();
                });
        }
    },
    mounted() {
        const kakaoScriptId = "kakao_script";
        if (!document.getElementById(kakaoScriptId)) {
            const script = document.createElement("script");
            script.src = "//developers.kakao.com/sdk/js/kakao.min.js";
            script.onload = () => {
                this.initiate(this);
            };
            script.onerror = error => this.handleError(error);
            script.id = kakaoScriptId;
            document.body.appendChild(script);
        } else {
            this.initiate(this);
        }
    },
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang]
            ? text[this.$store.state.lang]
            : text["en"];
        const gauthOption = {
            clientId: "",
            scope: "profile email",
            prompt: "select_account"
        };
        return {
            l10: l10n,
            email: "",
            password: "",
            msg: "",
            gauthOption: gauthOption,
            env: this.$store.state.env,
            kakaoLayer: false,
            lang: this.$store.state.lang,
        };
    },
    methods: {
        initiate() {
            if (!Kakao.isInitialized()) {
                Kakao.init("1ce9441cda247439191bea9b40f53e9d");
            }
        },
        handleError(error) {
            this.setErrorMsg("");
        },
        showKakaoLayer() {
            this.kakaoLayer = true;
        },
        closeKakaoLayer() {
            this.kakaoLayer = false;
        },
        async signinWithKakao(throughTalk) {
            try {
                const user = await this.kakaoAuthLogin(throughTalk);
                const token = user.access_token;
                this.$store
                    .dispatch("signinKakao", { token })
                    .then(() => {
                        this.redirect();
                    })
                    .catch(({ message }) => {
                        this.closeKakaoLayer();
                        this.setErrorMsg(this.$store.state.errCode);
                    });
            } catch (e) {
                this.closeKakaoLayer();
                this.setErrorMsg("");
            }
        },
        kakaoAuthLogin(throughTalk) {
            if (throughTalk) {
                return new Promise((resolve, reject) => {
                    Kakao.Auth.login({
                        throughTalk: true,
                        scope: "profile,account_email,phone_number",
                        success: authObj => {
                            resolve(authObj);
                        },
                        fail: err => {
                            reject(err);
                        }
                    })
                });
            } else {
                return new Promise((resolve, reject) => {
                    Kakao.Auth.loginForm({
                        scope: "profile,account_email,phone_number",
                        success: authObj => {
                            resolve(authObj);
                        },
                        fail: err => {
                            reject(err);
                        }
                    })
                });
            }
        },
        async signinWithGoogle() {
            try {
                const user = await this.$gAuth.signIn();
                const token = user.getAuthResponse().id_token;
                const checkRes = await axios.post(
                    this.env.protocol + this.env.urlAPI + "/account/checkGoogleOAuth",
                    {
                        token: token,
                        product: 'todomath'
                    },
                    {
                        headers: {
                            "content-type": "application/json; charset=UTF-8"
                        }
                    }
                );
				if (!checkRes.data.result || !checkRes.data.data) {
                    this.$store.commit('delGoogleToken');
                    this.setErrorMsg("");
                    return;
                }
				if (!checkRes.data.data.status && checkRes.data.data.emailStatusCode) {
                    this.$store.commit('delGoogleToken');
                    this.setErrorMsg(checkRes.data.data.emailStatusCode);
                    return;
                }

                this.$store.commit('setGoogleToken', token);
				if (checkRes.data.data.status) {
                    // signin
                    this.$store
                        .dispatch("signinGoogle", { token })
                        .then(() => {
                            this.redirect();
                        })
                        .catch(({ message }) => {
                            this.setErrorMsg(this.$store.state.errCode);
                        });
                }
				else {
                    // signup
                    const { search } = window.location;
                    this.$router.push("/signupAgreement" + search)
                    return;
                }
            } catch (e) {
                this.$store.commit('delGoogleToken');
                this.setErrorMsg("");
            }
        },
        signinWithEmail() {
            const { search } = window.location;
            this.$router.push("/signin/email" + search);
        },
        redirect() {
            this.$store.dispatch("redirect");
        },
        setErrorMsg(errCode) {
            if ( "All_Parents_Error_" + errCode in this.l10) {
                this.msg = this.l10["All_Parents_Error_" + errCode];
            } else {
                this.msg = "Unknown error occurred.";
            }
        }
    }
};
</script>

<style src="@/assets/account/main.css"></style>
<style scoped>
.top {
    height: 100px;
    background-color: #42c0ff;
}
.container {
    margin: 0 auto;
    height: auto;
    min-height: 100px;
    max-width: 1024px;
    background-color: #ffffff;
}
.content-wrap {
    background-color: #fffcf7;
    padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/account/Signin.vue